import React, { useEffect, useRef, useState } from "react";
import "./css/main.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

export default function Main_pre() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);

    const [shareOpen, setShareOpen] = useState(false);
    const closeShare = () => setShareOpen(false);

    const [flippedIdx, setFlippedIdx] = useState(null);
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") {
                setShareOpen(false);
                setFlippedIdx(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    // ✅ 목업 데이터 (접두어 없이 값만)
    const banners = [
        {
            type: "검정 중",
            number: "2020-005215",
            name: "클라이밍지도사",
            org: "대한스포츠클라이밍협회",
            status: "시험대기중",
            detail: "2025-11-16 오전 10시\n양재고등학교",
            acquired: "",
            renew: "",
            cta: "",
            gradient: "linear-gradient(160deg,#f26a5a 0%,#e74f6a 55%,#d2457a 100%)",
        },
        {
            type: "보유자격증",
            number: "2021-001122",
            name: "아로마컨설턴트 2급",
            org: "해피브릿지",
            status: "",
            detail: "",
            acquired: "2024-03-02",
            renew: "2026-01-01\n~ 2026-12-31",
            cta: "공유하기",
            gradient: "linear-gradient(160deg,#4b64ff 0%,#354ad8 55%,#2132b6 100%)",
        },
        {
            type: "보유자격증",
            number: "2020-005262",
            name: "클라이밍루트세팅전문가",
            org: "대한스포츠클라이밍협회",
            status: "",
            detail: "",
            acquired: "2024-10-13",
            renew: "2027-01-01\n~ 2027-12-31",
            cta: "공유하기",
            gradient: "linear-gradient(160deg,#5567f4 0%,#4850d9 55%,#3d3abf 100%)",
        },
        {
            type: "보유자격증",
            number: "2020-003260",
            name: "스포츠클라이밍안전관리사",
            org: "대한스포츠클라이밍협회",
            status: "",
            detail: "",
            acquired: "2024-10-13",
            renew: "2027-01-01\n~ 2027-12-31",
            cta: "공유하기",
            gradient: "linear-gradient(160deg,#5567f4 0%,#4850d9 55%,#3d3abf 100%)",
        },
    ];

    const toggleFlip = (i) => setFlippedIdx((p) => (p === i ? null : i));
    const onShareClick = (e) => {
        e.stopPropagation();
        setShareOpen(true);
    };

    return (
        <div className="container-wrap main-wrap">
            <div className="main-viewport">
                <header className="setting-header">
                    <img
                        src="/img/myCert.png"
                        alt="myCert"
                        className="setting-logo"
                        onClick={() => navigate("/")}
                    />
                </header>
                <main className="main-content">
                    <div className="main-swiper-area">
                        <Swiper
                            ref={swiperRef}
                            slidesPerView="auto"
                            centeredSlides
                            spaceBetween={25}
                            pagination={{ clickable: true, dynamicBullets: true }}
                            modules={[Pagination]}
                            loop={false}
                            slidesPerGroup={1}
                            freeMode={false}
                            longSwipes
                            longSwipesRatio={0.2}
                            longSwipesMs={180}
                            threshold={8}
                            speed={350}
                            onSlideChange={(swiper) => {
                                const diff = swiper.activeIndex - swiper.previousIndex;
                                if (diff > 1) swiper.slideTo(swiper.previousIndex + 1);
                                else if (diff < -1) swiper.slideTo(swiper.previousIndex - 1);
                                setFlippedIdx(null);
                            }}
                            className="main-swiper"
                        >
                            {banners.map((b, i) => {
                                const isFlipped = flippedIdx === i;
                                const isOwned = b.type === "보유자격증";
                                return (
                                    <SwiperSlide className="main-slide" key={i}>
                                        <article
                                            className={`main-card ${isFlipped ? "is-flipped" : ""}`}
                                            onClick={() => toggleFlip(i)}
                                        >
                                            {/* 상단 배지 위치 고정 */}
                                            <div className="main-type-badge">
                                                <img src="/img/icon.png" alt="" />
                                                {b.type}
                                            </div>

                                            <div className="main-card-inner">
                                                {/* ===== 앞면 ===== */}
                                                <div
                                                    className="main-card-face main-card-front"
                                                    style={{ background: b.gradient }}
                                                >
                                                    <div className="main-card-light" />

                                                    {/* 1) 상단 고정(기관/자격명) */}
                                                    <div className="front-top-fixed">
                                                        <h2 className="main-card-title">{b.org}</h2>
                                                        <p className="main-card-greet">{b.name}</p>
                                                    </div>

                                                    {/* 2) 가운데(세로 가운데 정렬) */}
                                                    <div className="front-center">
                                                        {!isOwned ? (
                                                            <>
                                                                <div className="front-row">
                                                                    <span className="k">상태</span>
                                                                    <span className="v">{b.status}</span>
                                                                </div>
                                                                <div className="front-row">
                                                                    <span className="k">상세정보</span>
                                                                    <span className="v">{b.detail}</span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="front-row">
                                                                    <span className="k">취득일</span>
                                                                    <span className="v">{b.acquired}</span>
                                                                </div>
                                                                <div className="front-row">
                                                                    <span className="k">갱신기간</span>
                                                                    <span className="v">{b.renew}</span>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>

                                                    {/* 3) 하단 CTA */}
                                                    <div className="main-card-footer">
                                                        {/* {b.cta && b.cta.length > 0 && (
                                                            <button
                                                                className="main-cta"
                                                                type="button"
                                                                onClick={onShareClick}
                                                            >
                                                                {b.cta}
                                                                <span className="main-cta-arrow" aria-hidden>
                                                                    <FontAwesomeIcon icon={faChevronRight} />
                                                                </span>
                                                            </button>
                                                        )} */}
                                                        <button className="main-cta" type="button">
                                                            상세정보 보기
                                                            <span className="main-cta-arrow" aria-hidden>
                                                                <FontAwesomeIcon icon={faChevronRight} />
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* ===== 뒷면 ===== */}
                                                <div className="main-card-face main-card-back">
                                                    <div className="main-back-content">
                                                        <h3 className="main-back-title">상세정보</h3>
                                                        <ul className="main-back-list">
                                                            {isOwned ? (
                                                                <>
                                                                    <li>
                                                                        <span className="k">자격번호</span>
                                                                        <span className="v">{b.number}</span>
                                                                    </li>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <li>
                                                                        <span className="k">수험번호</span>
                                                                        <span className="v">{b.number}</span>
                                                                    </li>
                                                                </>
                                                            )}
                                                            <li>
                                                                <span className="k">자격명</span>
                                                                <span className="v">{b.name}</span>
                                                            </li>
                                                            <li>
                                                                <span className="k">발급기관</span>
                                                                <span className="v">{b.org}</span>
                                                            </li>

                                                            {isOwned ? (
                                                                <>
                                                                    <li>
                                                                        <span className="k">취득일</span>
                                                                        <span className="v">{b.acquired}</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="k">갱신기간</span>
                                                                        <span className="v">{b.renew}</span>
                                                                    </li>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <li>
                                                                        <span className="k">상태</span>
                                                                        <span className="v">{b.status}</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="k">상세정보</span>
                                                                        <span className="v">{b.detail}</span>
                                                                    </li>
                                                                </>
                                                            )}
                                                        </ul>

                                                        <div className="main-back-actions">
                                                            {!isOwned ? (
                                                                <>
                                                                    <div></div>
                                                                    <button
                                                                        type="button"
                                                                        className="main-back-btn outline"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleFlip(i);
                                                                        }}
                                                                    >
                                                                        닫기
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="main-back-btn"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            navigate("/issuance", {
                                                                                state: {
                                                                                    cert: {
                                                                                        number: b.number,
                                                                                        name: b.name,
                                                                                        issuer: b.org,
                                                                                        acquired: b.acquired,
                                                                                        renew: b.renew,
                                                                                        amount: 50000,
                                                                                    },
                                                                                },
                                                                            });
                                                                        }}
                                                                    >
                                                                        자격증 발급신청
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="main-back-btn outline"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleFlip(i);
                                                                        }}
                                                                    >
                                                                        닫기
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </main>

                {shareOpen && (
                    <div
                        className="main-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="share-title"
                        onClick={closeShare}
                    >
                        <div className="main-modal-dialog" onClick={(e) => e.stopPropagation()}>
                            <div className="main-modal-body">
                                <h3 id="share-title" className="main-modal-title">공유되었습니다.</h3>
                                <p className="main-modal-desc">성공적으로 공유 처리되었습니다.</p>
                            </div>
                            <div className="main-modal-actions">
                                <button className="main-modal-btn" onClick={closeShare}>확인</button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ height: 100 }} />
            </div>
        </div>
    );
}
